import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { catchError, map, of } from "rxjs";
import { EventsManagementService } from "../app/services/events-management.service";

export const hasAccessGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const eventsService = inject(EventsManagementService);

  const eventId = route.paramMap.get("id");

  if (!eventId) {
    return of(router.createUrlTree(["/"]));
  }

  return eventsService.getMyEventById(eventId).pipe(
    map(() => {
      return true;
    }),
    catchError(() => of(router.createUrlTree(["/"]))),
  );
};
